'use strict';

import TwerLayers from './modules/layers';
import AColorPicker from 'a-color-picker';

const {__} = wp.i18n;

window.TWER = {};

var geo;

let worldsList = {};

/**
 * Insert a string at a specific index
 */
if (!String.prototype.splice) {
  /**
   * {JSDoc}
   *
   * The splice() method changes the content of a string by removing a range of
   * characters and/or adding new characters.
   *
   * @this {String}
   * @param {number} start Index at which to start changing the string.
   * @param {number} delCount An integer indicating the number of old chars to remove.
   * @param {string} newSubStr The String that is spliced in.
   * @return {string} A new string with the spliced substring.
   */
  String.prototype.splice = function(start, delCount, newSubStr) {
    return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
  };
}

jQuery.noConflict();
(function($) {
  $(function() {
    const $switchBearing = $('#treweler-camera-bearing');
    const $switchPitch = $('#treweler-camera-pitch');
    const $initialPitch = $('#treweler-camera-initial-pitch');
    const $initialPitchRange = $('#treweler-camera-initial-pitch-range');
    const $initialBearing = $('#treweler-camera-initial-bearing');
    const $initialBearingRange = $('#treweler-camera-initial-bearing-range');
    const $minPitchRange = $('#treweler-camera-min-pitch-range');
    const $minPitch = $('#range-treweler-camera-pitch-mr');
    const $maxPitchRange = $('#treweler-camera-max-pitch-range');
    const $maxPitch = $('#range-treweler-camera-pitch-mr-right');


      const mapGeolocateControl = new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        showAccuracyCircle: false,
        trackUserLocation: true,
        showUserHeading: true
      });


    /**
     * Initialize map
     */
    function init_map() {

        let lat = ($('#latitude').val().trim() != '' ? $('#latitude').val().trim() : '0.1'),
          lng = ($('#longitude').val().trim() != '' ? $('#longitude').val().trim() : '0.1'),
          zoom = ($('#setZoom').val().trim() != '' ? $('#setZoom').val() : 0.00),
          minZ = (parseFloat($('#setZoom_min_range').val()) != 0 ? parseFloat($('#setZoom_min_range').val()) : 0),
          maxZ = (parseFloat($('#setZoom_max_range').val()) != 0 ? parseFloat($('#setZoom_max_range').val()) : 24),
          iniPitch = (parseInt($initialPitch.val()) != 0) ? parseFloat($initialPitch.val()).toFixed(2) : 0,
          iniBearing = (parseInt($initialBearing.val()) != 0) ? parseFloat($initialBearing.val()).toFixed(2) : 0,
          minPitch = $switchPitch.prop('checked') ? parseFloat($minPitch.val()).toFixed(2) : 0,
          maxPitch = $switchPitch.prop('checked') ? parseFloat($maxPitch.val()).toFixed(2) : 85,
          styleType = ($('#custom_style').val().trim() != '' ? $('#custom_style').val() : $('#map_styles').val()),
          lightPreset =  $('#map_light_preset').val();

        const wordmarkPosition = document.getElementById('twer-wordmark-position');
        const attributionPosition = document.getElementById('twer-attribution-position');
        const compactAttribution = document.getElementById('twer-compact-attribution');









        function prepare_regions(choosedRegion) {
          if(!choosedRegion) return false;

          const [column, value = '', adminArea = '', adminNum = ''] = choosedRegion.split('_');

          return {
            column: column.toUpperCase().replace(/ /g, '_'),
            value: value,
            admin: adminArea.toUpperCase().replace(/ /g, '_'),
            admin_num: parseInt(adminNum)
          };
        }
      const projectionInput = document.getElementById('treweler_map_projection');

      if(lng === '0') {
        lng = 0.1;
      }
      if(lat === '0') {
        lat = 0.1;
      }
        mapboxgl.accessToken = twer_ajax.api_key;
        TWER.map = new mapboxgl.Map({
          container: 'map',
          style: styleType,
          center: [lng, lat],
          minZoom: minZ,
          maxZoom: maxZ,
          zoom: zoom,
          bearing: iniBearing,
          pitch: iniPitch,
          maxPitch: maxPitch,
          minPitch: minPitch,
          attributionControl: false,
          logoPosition: wordmarkPosition.options[wordmarkPosition.selectedIndex].value,
          projection: {
            name: projectionInput.value
          }
        });

      new TwerLayers();

      TWER.map.on('style.load', () => {
          TWER.map.setFog({});

          if( $('#map_styles').val() === 'mapbox://styles/mapbox/standard-beta' && $('#custom_style').val().trim() === '' ) {
            TWER.map.setConfigProperty('basemap', 'lightPreset', lightPreset);
          }
      });



      projectionInput.addEventListener('change', (e) => {
        TWER.map.setProjection(e.target.value);
      });

        let selectStateIds = [];
        let selectStateIdsColors = [];
        let hiddenRegionsIds = new Set();

        function generateFeatureStateFilter(settings = {}) {
          const fillMain = 'main' in settings ? settings.main : $('#treweler-boundaries-fill-main .input-color').val();
          const fillHover = 'hover' in settings ? settings.hover : $('#treweler-boundaries-fill-hover .input-color').val();
          const fillSelect = 'select' in settings ? settings.select : $('#treweler-boundaries-fill-selected .input-color').val();
          selectStateIdsColors = selectStateIdsColors.length > 0 ? selectStateIdsColors : $('#treweler-boundaries-regions-custom-colors').val().trim();

          if (!Array.isArray(selectStateIdsColors)) {
            if (selectStateIdsColors === '') {
              selectStateIdsColors = '[]';
            }
            selectStateIdsColors = JSON.parse(selectStateIdsColors);
          }

          const filter = [
            'match',
            ['feature-state', 'action'],
            'hover',
            fillHover,
            'select',
            fillSelect,
            'unselect',
            fillHover,
            'unhover',
            fillMain,
            fillMain
          ];

          if (selectStateIdsColors.length > 0) {
            let spliceCounter = 0;
            for (let i = 0; i < selectStateIdsColors.length; i++) {
              if (selectStateIdsColors[i].active) {
                let splice1 = 2 + spliceCounter;
                let splice2 = 3 + spliceCounter;
                filter.splice(splice1, 0, `customize_${selectStateIdsColors[i].id}`);
                filter.splice(splice2, 0, selectStateIdsColors[i].color);
                spliceCounter = spliceCounter + 2;
              }
            }
          }

          return filter;
        }

        function fillRegionColor(featureId, settings = {}) {
          const action = 'action' in settings ? settings.action : false;
          const filter = generateFeatureStateFilter(settings);

          for (let accuracy in worldsList) {
            TWER.map.setPaintProperty(`boundaries-${accuracy}-layer`, 'fill-color', filter);
            if (action) {
              let stateAction = action;
              switch (action) {
                case 'customize' :
                  stateAction = `customize_${featureId}`;
                  break;
              }
              TWER.map.setFeatureState(
                {source: accuracy, id: featureId},
                {action: stateAction}
              );
            }
          }

        }

        function selectRegions() {
          selectStateIds = selectStateIds.length > 0 ? selectStateIds : $('#treweler-boundaries-regions-selected').val().trim();

          if (!Array.isArray(selectStateIds)) {
            if (selectStateIds === '') {
              selectStateIds = '[]';
            }
            selectStateIds = JSON.parse(selectStateIds);
          }

          selectStateIdsColors = selectStateIdsColors.length > 0 ? selectStateIdsColors : $('#treweler-boundaries-regions-custom-colors').val().trim();

          if (!Array.isArray(selectStateIdsColors)) {
            if (selectStateIdsColors === '') {
              selectStateIdsColors = '[]';
            }
            selectStateIdsColors = JSON.parse(selectStateIdsColors);
          }

          if (selectStateIds.length > 0) {
            for (let i = 0; i < selectStateIds.length; i++) {
              fillRegionColor(selectStateIds[i], {action: 'select'});
            }
          }

          if (selectStateIdsColors.length > 0) {
            for (let i = 0; i < selectStateIdsColors.length; i++) {
              if (selectStateIdsColors[i].active && selectStateIds.includes(selectStateIdsColors[i].id)) {
                fillRegionColor(selectStateIdsColors[i].id, {action: 'customize'});
              }
            }
          }
        }

        function selectHiddenRegions() {
          hiddenRegionsIds = hiddenRegionsIds.size !== 0 ? hiddenRegionsIds : $('#treweler-boundaries-regions-hide').val().trim();

          if (typeof hiddenRegionsIds === 'string') {
            if (hiddenRegionsIds === '') {
              hiddenRegionsIds = '[]';
            }
            hiddenRegionsIds = new Set(JSON.parse(hiddenRegionsIds));
          }

          const regions = prepare_regions($('#treweler-boundaries-regions').val());
          let filter = ['all'];

          if ($('#treweler-boundaries-regions').val() !== 'world') {
            filter.push(['==', regions.column, regions.value]);

            if (regions.admin !== '') {
              filter.push(['==', regions.admin, regions.admin_num]);
            }
          } else {
            //filter.push(['!=', 'COUNTRY', 'France']);
          }

          if (hiddenRegionsIds.size !== 0) {
            hiddenRegionsIds.forEach(name => {
              filter.push(['!=', 'NAME', name]);
            });

            for (let key in worldsList) {
              TWER.map.setFilter(`boundaries-${key}-layer`, filter);
              TWER.map.setFilter(`boundaries-${key}-line-layer`, filter);
            }
          }
        }

        const wcv = $('#world_copy').prop('checked');
        TWER.map.setRenderWorldCopies(wcv);
        $('#world_copy').on('change', function() {
          TWER.map.setRenderWorldCopies($(this).prop('checked'));
        });


        TWER.map.on('load', async () => {
          let coloroverlay = $('#overlay-style-map').val();

          TWER.map.addLayer({
            id: 'bg-layer',
            type: 'background',
            paint: {
              'background-color': coloroverlay
            }
          });

        });

        function forEachLayer(text, cb) {
          TWER.map.getStyle().layers.forEach((layer) => {
            if (!layer.id.includes(text)) return;

            cb(layer);
          });
        }

        function changeStyle(style) {
          const savedLayers = [];
          const savedSources = {};
          const layerGroups = [
            'bg-layer',
            'boundaries-very_high-layer',
            'boundaries-high-layer',
            'boundaries-low-layer',
            'boundaries-very_low-layer',
            'boundaries-medium-layer',
            'boundaries-very_high-line-layer',
            'boundaries-high-line-layer',
            'boundaries-low-line-layer',
            'boundaries-very_low-line-layer',
            'boundaries-medium-line-layer'
          ];

          layerGroups.forEach((layerGroup) => {
            forEachLayer(layerGroup, (layer) => {
              if (layer.source) {
                savedSources[layer.source] = TWER.map.getSource(layer.source).serialize();
              }
              savedLayers.push(layer);
            });
          });

          TWER.map.setStyle(style);

          setTimeout(() => {
            Object.entries(savedSources).forEach(([id, source]) => {
              TWER.map.addSource(id, source);
            });

            if (savedLayers.length > 0) {
              savedLayers.forEach((layer) => {
                //console.log(layer);
                if (!TWER.map.getLayer(layer.id)) {
                  TWER.map.addLayer(layer);
                }
              });
            }

            if (selectStateIds.length > 0) {
              for (let i = 0; i < selectStateIds.length; i++) {
                for (let key in worldsList) {
                  TWER.map.setFeatureState(
                    {source: key, id: selectStateIds[i]},
                    {action: 'select'}
                  );
                }
              }
            } else {
              if($('#treweler-boundaries').prop('checked')) {
                selectRegions();
                selectHiddenRegions();
              }
            }
          }, 1000);
        }

        /**
         * Change center point
         */

        $('#map_styles').on('change', function() {
          if($('#custom_style').val().trim() !== '') return;

          let styleType = $(this).val();

          changeStyle(styleType);

          if($('#map_styles').val() === 'mapbox://styles/mapbox/standard-beta') {
            $('#map_light_preset').closest('.js-twer-row').removeClass('d-none');
          } else {
            $('#map_light_preset').closest('.js-twer-row').addClass('d-none');
          }

          if($('#map_styles').val() === 'mapbox://styles/mapbox/standard-beta') {
            TWER.map.setConfigProperty('basemap', 'lightPreset', $('#map_light_preset').val());
          }

        });


      $('#custom_style').on('change', function() {
        let styleType = $(this).val();
        if(styleType.trim() === '') {
          styleType = $('#map_styles').val();
          $('#twer-nav-layers-tab').removeClass('d-none');
        } else {
          $('#twer-nav-layers-tab').addClass('d-none');
          $('#twer-nav-general-tab').tab('show');
          //$("input[type='checkbox'][name^='_treweler_map_layers']").prop('checked', true);
        }

        changeStyle(styleType);

        $('#map_light_preset').closest('.js-twer-row').addClass('d-none');
      });

      $('#map_light_preset').on('change', function() {
        if ($('#map_styles').val() === 'mapbox://styles/mapbox/standard-beta' && $('#custom_style').val().trim() === '') {
          TWER.map.setConfigProperty('basemap', 'lightPreset', $('#map_light_preset').val());
        }
      });





      function toggleRestrictFields(value) {
        if (typeof value === 'undefined') {
          value = $('#treweler-restrict-panning').prop('checked');
        }
        if (value) {
          $('.section-treweler-restrict-panning-southwest, .section-treweler-restrict-panning-northeast').css('display', 'table-row');
        } else {
          $('.section-treweler-restrict-panning-southwest, .section-treweler-restrict-panning-northeast').css('display', 'none');
        }
      }
        $(document).on('change', '#treweler-restrict-panning', (e) => {
          toggleRestrictFields(e.target.checked);
        });
        toggleRestrictFields();

        /**
         * Get Lat/Lng, zoom value on zoom
         */
        TWER.map.on('zoom', function() {
          /* If latlng preview is checked */
          if ($('#latlng_map_prev').prop('checked')) {
            let llZ = TWER.map.getCenter();
            $('#longitude').val(llZ.lng);
            $('#latitude').val(llZ.lat);
          }
          /* If zoom preview is checked */
          if ($('#zoom_map_prev').prop('checked')) {
            let zoomZ = parseFloat(TWER.map.getZoom()).toFixed(2);
            if (zoomZ.trim() == '' || zoomZ.trim() == 'NaN' || zoomZ == 0.00 || zoomZ == 0.23) {
              zoomZ = 0;
            }
            $('#setZoom_range').val(zoomZ);
            $('#setZoom').val(zoomZ);
          }
        });

        /**
         * Add Map DCompact attribution
         */
        TWER.map.addControl(new mapboxgl.AttributionControl({
          compact: compactAttribution.checked
        }), attributionPosition.options[attributionPosition.selectedIndex].value);

        /**
         * Add Map Diststance Scale Control
         */
        if ($('#treweler-map-controls-distance-scale').length && $('#treweler-map-controls-distance-scale').prop('checked')) {
          const unit = $('#treweler-map-controls-distance-unit').val();
          TWER.map.addControl(new mapboxgl.ScaleControl({
            maxWidth: 100,
            unit: unit ? unit : 'imperial'
          }), $('#treweler-map-controls-distance-position').val());
        }

        /**
         * Add Map Fullscreen Control
         */
        if ($('#treweler-map-controls-fullscreen').length && $('#treweler-map-controls-fullscreen').prop('checked')) {
          TWER.map.addControl(new mapboxgl.FullscreenControl(), $('#treweler-map-controls-fullscreen-position').val());
          //$(TWER.map._container).find('.mapboxgl-ctrl-fullscreen').parent('.mapboxgl-ctrl-group').addClass('treweler-fs-ctrl');
        }

        /**
         * Add Map Search Control
         */
        if ($('#treweler-map-controls-search').length && $('#treweler-map-controls-search').prop('checked')) {
          TWER.map.addControl(
            geo = new MapboxGeocoder({
              accessToken: mapboxgl.accessToken,
              zoom: 14,
              placeholder: 'Enter search...',
              mapboxgl: mapboxgl,
              marker: false
            }), $('#treweler-map-controls-search-position').val()
          );
          geo.on('result', function(res) {
            let latlng = res.result.center;
            $('#latitude').val(latlng[1]);
            $('#longitude').val(latlng[0]);
          });
        }

        /**
         * Add Map Zoom Pan Control
         */
        if ($('#treweler-map-controls-zoom-pan').length && $('#treweler-map-controls-zoom-pan').prop('checked')) {
          TWER.map.addControl(new mapboxgl.NavigationControl(), $('#treweler-map-controls-zoom-pan-position').val()); //top-left , top-right , bottom-left , bottom-right
          //$(TWER.map._container).find('.mapboxgl-ctrl-zoom-in').parent('.mapboxgl-ctrl-group').addClass('treweler-zp-ctrl');
        }

        /**
         * Add Map Geolocate Control
         */
        if ($('#treweler-map-controls-geolocate').length && $('#treweler-map-controls-geolocate').prop('checked')) {

          TWER.map.addControl(mapGeolocateControl, $('#treweler-map-controls-geolocate-position').val());

          if($('#treweler-map-controls-geolocate-style').val() === 'treweler-style') {
            mapGeolocateControl._container.classList.add('twer-geolocation-control');
          } else {
            mapGeolocateControl._container.classList.remove('twer-geolocation-control');
          }
        }

        /**
         * If 'Use the map preview' is checked for latlng
         */
        if ($('#latlng_map_prev').length && $('#latlng_map_prev').prop('checked')) {
          $('#latitude').attr('readonly', 'readonly');
          $('#longitude').attr('readonly', 'readonly');

          /* Enable Map Drag */
          TWER.map.dragPan.enable();
          TWER.map.dragRotate.enable();
          TWER.map.on('drag', function() {
            let lnglatC = TWER.map.getCenter();
            $('#longitude').val(lnglatC.lng);
            $('#latitude').val(lnglatC.lat);
          });
        } else {
          $('#latitude').removeAttr('readonly');
          $('#longitude').removeAttr('readonly');

          /* Disable Map Drag */
          TWER.map.dragPan.disable();
          TWER.map.dragRotate.disable();
        }

        /**
         * If 'Use the map preview' is checked for zoom
         */
        if ($('#zoom_map_prev').length && $('#zoom_map_prev').prop('checked')) {
          $('#setZoom_range').attr('disabled', 'disabled');
          $('#setZoom').attr('readonly', 'readonly');

          /* Enable Map Zoom on click/scroll */
          TWER.map.doubleClickZoom.enable();
          TWER.map.scrollZoom.enable();
          if (!$('#latlng_map_prev').prop('checked') && $('#zoom_map_prev').prop('checked')) {
            TWER.map.on('wheel', function(e) {
              let mZoom = parseFloat(TWER.map.getZoom()).toFixed(2),
                latW = parseFloat($('#latitude').val()),
                lngW = parseFloat($('#longitude').val());
              TWER.map.scrollZoom.setWheelZoomRate(1);
              TWER.map.zoomTo(mZoom, {center: [lngW, latW]});
            });
            TWER.map.on('dblclick', function(e) {
              if (!$('#latlng_map_prev').prop('checked') && $('#zoom_map_prev').prop('checked')) {
                e.preventDefault();
                let dcZoom = parseInt(TWER.map.getZoom()),
                  latDC = parseFloat($('#latitude').val()),
                  lngDC = parseFloat($('#longitude').val());
                $('#setZoom').val(dcZoom);
                $('#setZoom_range').val(dcZoom);
                e.lngLat.lng = lngDC;
                e.lngLat.lat = latDC;
                e._defaultPrevented = false;
                TWER.map.doubleClickZoom.enable();
                TWER.map.zoomTo(dcZoom, {center: [lngDC, latDC]});
              }
            });
          }

        } else {
          $('#setZoom_range').removeAttr('disabled');
          $('#setZoom').removeAttr('readonly');

          /* Disable Map Zoom on click/scroll */
          TWER.map.doubleClickZoom.disable();
          TWER.map.scrollZoom.disable();
        }

    }

    if ($('#map').length) {

      init_map();

      $('.section-treweler-map-controls select').on('change', function() {
        const position = $(this).val();
        const id = $(this).attr('id');

        switch (id) {
          case 'treweler-map-controls-distance-position' :
            if ($('#treweler-map-controls-distance-scale').prop('checked')) {
              TWER.map._controls.forEach((value, index) => {
                if (value.constructor.name === 'ScaleControl') {
                  $(TWER.map._container).find('.mapboxgl-ctrl-scale').remove();

                  const unit = $('#treweler-map-controls-distance-unit').val();

                  console.log(unit);

                  TWER.map.addControl(new mapboxgl.ScaleControl({maxWidth: 100, unit: unit ? unit : 'imperial'}), position);
                }
              });
            }
            break;
          case 'treweler-map-controls-fullscreen-position' :
            if ($('#treweler-map-controls-fullscreen').prop('checked')) {
              TWER.map._controls.forEach((value, index) => {
                if (value.constructor.name === 'FullscreenControl') {
                  $(TWER.map._container).find('.mapboxgl-ctrl-fullscreen').parent('.mapboxgl-ctrl-group').remove();
                  TWER.map.addControl(new mapboxgl.FullscreenControl(), position);
                }
              });
            }
            break;
          case 'treweler-map-controls-search-position' :
            if ($('#treweler-map-controls-search').prop('checked')) {
              $(TWER.map._container).find('.mapboxgl-ctrl-geocoder').remove();
              var geo = new MapboxGeocoder({
                accessToken: mapboxgl.accessToken,
                zoom: 14,
                placeholder: 'Enter search...',
                mapboxgl: mapboxgl,
                marker: false
              });
              TWER.map.addControl(geo, position);
              geo.on('result', function(res) {
                let latlng = res.result.center;
                $('#latitude').val(latlng[1]);
                $('#longitude').val(latlng[0]);
              });
            }
            break;
          case 'treweler-map-controls-zoom-pan-position' :
            if ($('#treweler-map-controls-zoom-pan').prop('checked')) {
              TWER.map._controls.forEach((value, index) => {
                if (value.constructor.name === 'NavigationControl') {
                  $(TWER.map._container).find('.mapboxgl-ctrl-zoom-in').parent('.mapboxgl-ctrl-group').remove();
                  TWER.map.addControl(new mapboxgl.NavigationControl(), position);
                }
              });
            }
            break;
          case 'treweler-map-controls-geolocate-position' :
            if ($('#treweler-map-controls-geolocate').prop('checked')) {
              TWER.map.removeControl(mapGeolocateControl);
              TWER.map.addControl(mapGeolocateControl, position);
              if($('#treweler-map-controls-geolocate-style').val() === 'treweler-style') {
                mapGeolocateControl._container.classList.add('twer-geolocation-control');
              } else {
                mapGeolocateControl._container.classList.remove('twer-geolocation-control');
              }
            }
            break;
          case 'treweler-map-controls-geolocate-style' :
            if ($('#treweler-map-controls-geolocate').prop('checked')) {
              const currentStyles = $('#treweler-map-controls-geolocate-style').val();

              if (currentStyles === 'treweler-style') {
                $('.mapboxgl-ctrl-geolocate').parent().addClass('twer-geolocation-control');
              } else {
                $('.mapboxgl-ctrl-geolocate').parent().removeClass('twer-geolocation-control');
              }
            }
            break;
        }
      });

      $('#treweler-map-controls-distance-unit').on('change', function(){
        const unit = $(this).val();

        if ($('#treweler-map-controls-distance-scale').prop('checked')) {
          TWER.map._controls.forEach((value, index) => {
            if (value.constructor.name === 'ScaleControl') {
              $(TWER.map._container).find('.mapboxgl-ctrl-scale').remove();
              TWER.map.addControl(new mapboxgl.ScaleControl({maxWidth: 100, unit: unit ? unit : 'imperial'}), $('#treweler-map-controls-distance-position').val());
            }
          });
        }
      });


      /* Controls */
      $('input[type="checkbox"]').on('change', function() {

        /* Distance Scale Control */
        if ($(this).val() === 'distance_scale') {

          const unit = $('#treweler-map-controls-distance-unit').val();
          console.log(unit);
          var ds = new mapboxgl.ScaleControl({maxWidth: 100, unit: unit ? unit : 'imperial'});
          if ($(this).prop('checked')) {
            TWER.map.addControl(ds, $('#treweler-map-controls-distance-position').val());
          } else {
            $(TWER.map._container).find('.mapboxgl-ctrl-scale').remove();
          }
        }

        /* Fullscreen control */
        if ($(this).val() === 'fullscreen') {
          var fs = new mapboxgl.FullscreenControl();
          if ($(this).prop('checked')) {
            TWER.map.addControl(fs, $('#treweler-map-controls-fullscreen-position').val());
            //$(TWER.map._container).find('.mapboxgl-ctrl-fullscreen').parent('.mapboxgl-ctrl-group').addClass('treweler-fs-ctrl');
          } else {
            $(TWER.map._container).find('.mapboxgl-ctrl-fullscreen').parent('.mapboxgl-ctrl-group').remove();
          }
        }

        /* Search Control */
        if ($(this).val() === 'search') {
          if ($(this).prop('checked')) {
            var geo = new MapboxGeocoder({
              accessToken: mapboxgl.accessToken,
              zoom: 14,
              placeholder: 'Enter search...',
              mapboxgl: mapboxgl,
              marker: false
            });
            TWER.map.addControl(geo, $('#treweler-map-controls-search-position').val());
            geo.on('result', function(res) {
              let latlng = res.result.center;
              $('#latitude').val(latlng[1]);
              $('#longitude').val(latlng[0]);
            });
          } else {
            $(TWER.map._container).find('.mapboxgl-ctrl-geocoder').remove();
          }
        }

        /* Zoom & Pan Control */
        if ($(this).val() === 'zoom_pan') {
          var zp = new mapboxgl.NavigationControl();
          if ($(this).prop('checked')) {
            TWER.map.addControl(zp, $('#treweler-map-controls-zoom-pan-position').val());
            //$(TWER.map._container).find('.mapboxgl-ctrl-zoom-in').parent('.mapboxgl-ctrl-group').addClass('treweler-zp-ctrl');
          } else {
            $(TWER.map._container).find('.mapboxgl-ctrl-zoom-in').parent('.mapboxgl-ctrl-group').remove();
          }
        }

        /*Geolocate control*/
        if ($(this).val() === 'geolocate') {
          if ($(this).prop('checked')) {
            TWER.map.addControl(mapGeolocateControl, $('#treweler-map-controls-geolocate-position').val());
            //$(TWER.map._container).find('.mapboxgl-ctrl-geolocate').parent('.mapboxgl-ctrl-group').addClass('treweler-go-ctrl');
            if($('#treweler-map-controls-geolocate-style').val() === 'treweler-style') {
              mapGeolocateControl._container.classList.add('twer-geolocation-control');
            } else {
              mapGeolocateControl._container.classList.remove('twer-geolocation-control');
            }
          } else {
            TWER.map.removeControl(mapGeolocateControl);
          }
        }
      });

      /**
       * Enable Map Pan If "Use the map preview" is checked
       */
      $('input[type="checkbox"]#latlng_map_prev, input[type="checkbox"]#zoom_map_prev').on('change', function() {
        /* Map View Point Control Preview */
        if ($(this).attr('id') == 'latlng_map_prev') {
          if ($(this).prop('checked')) {
            $('#latitude').attr('readonly', 'readonly');
            $('#longitude').attr('readonly', 'readonly');

            /* Enable Map Drag */
            TWER.map.dragPan.enable();
            TWER.map.dragRotate.enable();
            TWER.map.on('drag', function() {
              let lnglatC = TWER.map.getCenter();
              $('#longitude').val(lnglatC.lng);
              $('#latitude').val(lnglatC.lat);
            });
          } else {
            $('#latitude').removeAttr('readonly');
            $('#longitude').removeAttr('readonly');

            /* Disable Map Drag */
            TWER.map.dragPan.disable();
            TWER.map.dragRotate.disable();
          }
        }

        /* Map Zoom Control Preview */
        if ($(this).attr('id') == 'zoom_map_prev') {
          if ($(this).prop('checked')) {
            $('#setZoom_range').attr('disabled', 'disabled');
            $('#setZoom').attr('readonly', 'readonly');

            /* Enable Map Zoom on click/scroll */
            TWER.map.doubleClickZoom.enable();
            TWER.map.scrollZoom.enable();
            TWER.map.dragRotate.enable();
          } else {
            $('#setZoom_range').removeAttr('disabled');
            $('#setZoom').removeAttr('readonly');

            /* Disable Map Zoom on click/scroll */
            TWER.map.doubleClickZoom.disable();
            TWER.map.scrollZoom.disable();
            TWER.map.dragRotate.disable();
          }
        }

        /* Map Latlng prev checkbox unchecked & zoom prev checked */
        if (!$('#latlng_map_prev').prop('checked') && $('#zoom_map_prev').prop('checked')) {
          TWER.map.on('wheel', function(e) {
            if (!$('#latlng_map_prev').prop('checked') && $('#zoom_map_prev').prop('checked')) {
              TWER.map.scrollZoom.setWheelZoomRate(1);
              let mZoom = parseFloat(TWER.map.getZoom()).toFixed(2),
                latW = parseFloat($('#latitude').val()),
                lngW = parseFloat($('#longitude').val());
              TWER.map.zoomTo(mZoom, {center: [lngW, latW]});
            }
          });
          TWER.map.on('dblclick', function(e) {
            if (!$('#latlng_map_prev').prop('checked') && $('#zoom_map_prev').prop('checked')) {
              e.preventDefault();
              let dcZoom = parseInt(TWER.map.getZoom()),
                latDC = parseFloat($('#latitude').val()),
                lngDC = parseFloat($('#longitude').val());
              $('#setZoom').val(dcZoom);
              $('#setZoom_range').val(dcZoom);
              e.lngLat.lng = lngDC;
              e.lngLat.lat = latDC;
              e._defaultPrevented = false;
              TWER.map.doubleClickZoom.enable();
              TWER.map.zoomTo(dcZoom, {center: [lngDC, latDC]});
            }
          });
        }
      });

      /**
       * Change zoom level based on control value
       */
      $('#latitude, #longitude').on('change keyup', function() {
        if ($('#latitude').val().trim() != '' && $('#longitude').val().trim() != '') {
          TWER.map.setCenter([$('#longitude').val(), $('#latitude').val()]);
        }
      });

      /**
       * Change zoom level based on control value
       */
      $('#setZoom, #setZoom_range').on('input', function() {
        let zoomCC = parseFloat($(this).val()).toFixed(2),
          latN = parseFloat($('#latitude').val()),
          lngN = parseFloat($('#longitude').val());
        if (zoomCC.trim() == '' || zoomCC.trim() == 'NaN' || zoomCC == 0.00 || zoomCC == 0.23) {
          zoomCC = 0;
        }
        TWER.map.zoomTo(zoomCC, {center: [lngN, latN], duration: 2000});
        if ($(this).attr('id') == 'setZoom') {
          $('#setZoom_range').val(zoomCC);
        } else {
          $('#setZoom').val(zoomCC);
        }
      });

      /**
       * Change zoom level based on control value
       */
      $('.js-zoom-range, .js-zoom-range-input').on('input', function() {
        let zoomCC = parseFloat($(this).val()).toFixed(2);
        if (zoomCC.trim() == '' || zoomCC.trim() == 'NaN' || zoomCC == 0.00 || zoomCC == 0.23) {
          zoomCC = 0;
        }

        if ($(this).data('id') == 'range-input') {
          $(this).closest('.js-twer-range').find('.js-zoom-range').val(zoomCC);
        } else {
          $(this).closest('.js-twer-range').find('.js-zoom-range-input').val(zoomCC);
        }
      });

      $('.twer-root').each(function() {
        $(this).find('[data-toggle="tooltip"]').tooltip({
          container: $(this).closest('.twer-root')
        });
      });

      /**
       * Set zoom min/max level
       */
      $('#setZoom_min_range, #setZoom_max_range').on('input', function() {
        let lR = parseFloat($('#setZoom_min_range').val());
        let uR = parseFloat($('#setZoom_max_range').val());

        if ($(this).hasClass('lower-slider')) {
          if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $('.upper-slider').removeClass('active');
          }
          if (uR <= lR + 1) {
            $('#setZoom_max_range').val(lR + 2);
            if (uR == lR) {
              $('#setZoom_max_range').val(lR + 2);
            }
          }
        } else if ($(this).hasClass('upper-slider')) {
          if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $('.lower-slider').removeClass('active');
          }
          if (lR >= uR - 1) {
            $('#setZoom_min_range').val(uR - 2);
            if (uR == lR) {
              $('#setZoom_min_range').val(uR - 2);
            }
          }
        }
        let min = parseFloat($('#setZoom_min_range').val()), max = parseFloat($('#setZoom_max_range').val());

        $('#default_min_zoom').val(min);
        $('#default_max_zoom').val(max);
        $('#setZoom_range').attr({'min': min, 'max': max});
        $('#setZoom').attr({'min': min, 'max': max});

        if (min >= parseFloat($('#setZoom').val())) {
          $('#setZoom').val(min);
          $('#setZoom_range').val(min).trigger('input');
        } else if (max <= parseFloat($('#setZoom').val())) {
          $('#setZoom').val(max);
          $('#setZoom_range').val(max).trigger('input');
        }
        TWER.map.setMinZoom(min);
        TWER.map.setMaxZoom(max);
      });

      /**
       * Set zoom min/max level from input box
       */
      $('#default_min_zoom, #default_max_zoom').on('input', function() {
        let minI = parseFloat($('#default_min_zoom').val()), maxI = parseFloat($('#default_max_zoom').val());
        $('#setZoom_min_range').val(minI);
        $('#setZoom_max_range').val(maxI);
        $('#setZoom_range').attr({'min': minI, 'max': maxI});
        $('#setZoom').attr({'min': minI, 'max': maxI});

        if (minI >= parseFloat($('#setZoom').val())) {
          $('#setZoom').val(minI);
          $('#setZoom_range').val(minI).trigger('input');
        } else if (maxI <= parseFloat($('#setZoom').val())) {
          $('#setZoom').val(maxI);
          $('#setZoom_range').val(maxI).trigger('input');
        }
        TWER.map.setMinZoom(minI);
        TWER.map.setMaxZoom(maxI);
      });

    }

    /**
     * Color picker for map clusters
     */
    $('#color-picker-btn, .clr-picker span').on('click', function() {
      if ($('.color-picker').find('.a-color-picker').length === 0) {
        TWER_HELPERS.AColorPicker.from('.color-picker').on('change', (picker, color) => {
          $('.clr-picker span').css('background-color', picker.color);
          $('#clusterColor').val(picker.color);
          $('.color-picker').attr('acp-color', picker.color);
        }).on('coloradd', (picker, color) => {
          let cca = $('#addCustomColor');
          if (cca.val().indexOf('|' + color) === -1) {
            cca.val(cca.val() + '|' + color);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: cca.val()},
              success: function(response) {
                let eleCP = $('.color-picker'), defaultCP = eleCP.attr('default-palette');
                eleCP.attr('acp-palette', defaultCP + '' + response);
                $('.color-picker-text-name').attr('acp-palette', defaultCP + '' + response);
                $('.color-picker-text-descr').attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        }).on('colorremove', (picker, color) => {
          let ccr = $('#addCustomColor');
          if (ccr.val().indexOf('|' + color) != -1) {
            let sc = ccr.val().replace('|' + color, '');
            ccr.val(sc);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: ccr.val()},
              success: function(response) {
                let eleCP = $('.color-picker'), defaultCP = eleCP.attr('default-palette');
                eleCP.attr('acp-palette', defaultCP + '' + response);
                $('.color-picker-text-name').attr('acp-palette', defaultCP + '' + response);
                $('.color-picker-text-descr').attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        });

      } else {
        $('.color-picker').find('.a-color-picker').remove();
      }
    });

    $(window).on('click', function(event) {
      if (!$(event.target).hasClass('a-color-picker') && $(event.target).parents('.a-color-picker').length == 0 && $(event.target).attr('id') != 'color-picker-btn' && !$(event.target).hasClass('color-holder') && !$(event.target).hasClass('a-color-picker-palette-color')) {
        $('.color-picker').find('.a-color-picker').remove();
      }
    });

    $('#text-name-color-picker-btn, #map-text-color-name span').on('click', function() {
      if ($('.color-picker-text-name').find('.a-color-picker').length === 0) {
        TWER_HELPERS.AColorPicker.from('.color-picker-text-name').on('change', (picker, color) => {
          $('#map-text-color-name span').css('background-color', picker.color);
          $('#map_name_color').val(picker.color);
          $('.color-picker-text-name').attr('acp-color', picker.color);
        }).on('coloradd', (picker, color) => {
          let cca = $('#addCustomColor');
          if (cca.val().indexOf('|' + color) === -1) {
            cca.val(cca.val() + '|' + color);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: cca.val()},
              success: function(response) {
                let eleCP = $('.color-picker-text-name'), defaultCP = eleCP.attr('default-palette');
                eleCP.attr('acp-palette', defaultCP + '' + response);
                $('.color-picker-text-descr').attr('acp-palette', defaultCP + '' + response);
                $('.color-picker').attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        }).on('colorremove', (picker, color) => {
          let ccr = $('#addCustomColor');
          if (ccr.val().indexOf('|' + color) != -1) {
            let sc = ccr.val().replace('|' + color, '');
            ccr.val(sc);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: ccr.val()},
              success: function(response) {
                let eleCP = $('.color-picker-text-name'), defaultCP = eleCP.attr('default-palette');
                eleCP.attr('acp-palette', defaultCP + '' + response);
                $('.color-picker-text-descr').attr('acp-palette', defaultCP + '' + response);
                $('.color-picker').attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        });

      } else {
        $('.color-picker-text-name').find('.a-color-picker').remove();
      }
    });

    $(window).on('click', function(event) {
      if (!$(event.target).hasClass('a-color-picker') && $(event.target).parents('.a-color-picker').length == 0 && $(event.target).attr('id') != 'text-name-color-picker-btn' && !$(event.target).hasClass('color-holder') && !$(event.target).hasClass('a-color-picker-palette-color')) {
        $('.color-picker-text-name').find('.a-color-picker').remove();
      }
    });

    $('#text-descr-color-picker-btn, #map-text-color-descr span').on('click', function() {
      if ($('.color-picker-text-descr').find('.a-color-picker').length === 0) {
        TWER_HELPERS.AColorPicker.from('.color-picker-text-descr').on('change', (picker, color) => {
          $('#map-text-color-descr span').css('background-color', picker.color);
          $('#map_description_color').val(picker.color);
          $('.color-picker-text-descr').attr('acp-color', picker.color);
        }).on('coloradd', (picker, color) => {
          let cca = $('#addCustomColor');
          if (cca.val().indexOf('|' + color) === -1) {
            cca.val(cca.val() + '|' + color);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: cca.val()},
              success: function(response) {
                let eleCP = $('.color-picker-text-descr'), defaultCP = eleCP.attr('default-palette');
                eleCP.attr('acp-palette', defaultCP + '' + response);
                $('.color-picker-text-name').attr('acp-palette', defaultCP + '' + response);
                $('.color-picker').attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        }).on('colorremove', (picker, color) => {
          let ccr = $('#addCustomColor');
          if (ccr.val().indexOf('|' + color) != -1) {
            let sc = ccr.val().replace('|' + color, '');
            ccr.val(sc);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: ccr.val()},
              success: function(response) {
                let eleCP = $('.color-picker-text-descr'), defaultCP = eleCP.attr('default-palette');
                eleCP.attr('acp-palette', defaultCP + '' + response);
                $('.color-picker-text-name').attr('acp-palette', defaultCP + '' + response);
                $('.color-picker').attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        });

      } else {
        $('.color-picker-text-descr').find('.a-color-picker').remove();
      }
    });

    $(window).on('click', function(event) {
      if (!$(event.target).hasClass('a-color-picker') && $(event.target).parents('.a-color-picker').length == 0 && $(event.target).attr('id') != 'text-descr-color-picker-btn' && !$(event.target).hasClass('color-holder') && !$(event.target).hasClass('a-color-picker-palette-color')) {
        $('.color-picker-text-descr').find('.a-color-picker').remove();
      }
    });

    // Universal init color pickers
    $('.js-twer-color-picker').on('click', function(event) {
      event.stopPropagation();
      var $colorPicker = $(this);
      var $colorPickerCell = $colorPicker.children('span');
      var $colorPickerWrap = $colorPicker.closest('.js-twer-color-picker-wrap');
      var $palette = $colorPickerWrap.find('.js-twer-color-picker-palette');
      var $colorInput = $colorPickerWrap.find('input[type="hidden"]');

      if ($palette.find('.a-color-picker').length === 0) {
        TWER_HELPERS.AColorPicker.from($palette[0]).on('change', (picker, color) => {
          $colorPickerCell.css('background-color', picker.color);
          $colorInput.val(picker.color);
          $palette.attr('acp-color', picker.color);
        }).on('coloradd', (picker, color) => {
          let cca = $('#addCustomColor');
          if (cca.val().indexOf('|' + color) === -1) {
            cca.val(cca.val() + '|' + color);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: cca.val()},
              success: function(response) {
                let defaultCP = $palette.attr('default-palette');
                $palette.attr('acp-palette', defaultCP + '' + response);
                $palette.attr('acp-palette', defaultCP + '' + response);
                $('.color-picker').attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        }).on('colorremove', (picker, color) => {
          let ccr = $('#addCustomColor');
          if (ccr.val().indexOf('|' + color) != -1) {
            let sc = ccr.val().replace('|' + color, '');
            ccr.val(sc);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: ccr.val()},
              success: function(response) {
                let defaultCP = $palette.attr('default-palette');
                $palette.attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        });

      } else {
        $palette.find('.a-color-picker').remove();
      }

    });
    $('.js-twer-color-picker-palette').on('click', function(event) {
      event.stopPropagation();
    });
    $(window).on('click', function() {
      $('.js-twer-color-picker-palette').find('.a-color-picker').remove();
    });

    /**
     * `shortcode` generation dynamic events
     */
    if ($('#sc_shortcode').length) {

      $('#sc_isFullwidth').on('change', function() {

        let sc = $('#sc_shortcode').val(),
          fw = 'type="fullwidth"';

        if ($(this).prop('checked') && sc.indexOf(fw) === -1) {
          sc = sc.splice(-1, 0, ' ' + fw);
          $('#sc_shortcode').val(sc);
        } else {
          sc = sc.replace(' ' + fw, '');
          $('#sc_shortcode').val(sc);
        }

      });

      $('#sc_isScrollZoom').on('change', function() {

        let sc = $('#sc_shortcode').val(),
          sz = 'scrollzoom="no"';

        if ($(this).prop('checked') && sc.indexOf(sz) === -1) {
          sc = sc.splice(-1, 0, ' ' + sz);
          $('#sc_shortcode').val(sc);
        } else {
          sc = sc.replace(' ' + sz, '');
          $('#sc_shortcode').val(sc);
        }

      });

      $('#sc_width, #sc_height').on('input', function() {

        let sc = $('#sc_shortcode').val();

        if ($(this).attr('id') === 'sc_width') {

          let w = 'width="' + $(this).val() + $('#sc_width_unit').val() + '"';
          if (sc.indexOf('width=') === -1) {
            sc = sc.splice(-1, 0, ' ' + w);
            $('#sc_shortcode').val(sc);
          } else {
            let lastIdx = sc.indexOf('"', sc.indexOf('width="') + 'width="'.length);
            sc = sc.replace(sc.substring(sc.indexOf(' width="'), lastIdx + 1), '');
            if ($(this).val().trim() != '' && !isNaN($(this).val())) {
              sc = sc.splice(-1, 0, ' ' + w);
            }
            $('#sc_shortcode').val(sc);
          }

        } else if ($(this).attr('id') === 'sc_height') {

          let h = 'height="' + $(this).val() + $('#sc_height_unit').val() + '"';
          if (sc.indexOf('height=') === -1) {
            sc = sc.splice(-1, 0, ' ' + h);
            $('#sc_shortcode').val(sc);
          } else {
            let lastIdx = sc.indexOf('"', sc.indexOf('height="') + 'height="'.length);
            sc = sc.replace(sc.substring(sc.indexOf(' height="'), lastIdx + 1), '');
            if ($(this).val().trim() != '' && !isNaN($(this).val())) {
              sc = sc.splice(-1, 0, ' ' + h);
            }
            $('#sc_shortcode').val(sc);
          }

        }

      });

      $('#sc_width_unit, #sc_height_unit').on('input', function() {

        let sc = $('#sc_shortcode').val();

        if ($(this).attr('id') === 'sc_width_unit') {

          let w = 'width="' + $('#sc_width').val() + $('#sc_width_unit').val() + '"';
          if (sc.indexOf('width=') === -1) {
            sc = sc.splice(-1, 0, ' ' + w);
            $('#sc_shortcode').val(sc);
          } else {
            let lastIdx = sc.indexOf('"', sc.indexOf('width="') + 'width="'.length);
            sc = sc.replace(sc.substring(sc.indexOf(' width="'), lastIdx + 1), '');
            if ($('#sc_width').val().trim() != '' && !isNaN($('#sc_width').val())) {
              sc = sc.splice(-1, 0, ' ' + w);
            }
            $('#sc_shortcode').val(sc);
          }

        } else if ($(this).attr('id') === 'sc_height_unit') {

          let h = 'height="' + $('#sc_height').val() + $('#sc_height_unit').val() + '"';
          if (sc.indexOf('height=') === -1) {
            sc = sc.splice(-1, 0, ' ' + h);
            $('#sc_shortcode').val(sc);
          } else {
            let lastIdx = sc.indexOf('"', sc.indexOf('height="') + 'height="'.length);
            sc = sc.replace(sc.substring(sc.indexOf(' height="'), lastIdx + 1), '');
            if ($('#sc_height').val().trim() != '' && !isNaN($('#sc_height').val())) {
              sc = sc.splice(-1, 0, ' ' + h);
            }
            $('#sc_shortcode').val(sc);
          }

        }

      });

      $('#copy_shortcode_btn').on('click', function() {
        document.getElementById('sc_shortcode').select();
        document.execCommand('copy');
      });

    }

    /**
     * Pitch & Bearing Options
     */

    const $sectionMultiRange = $('.section-treweler-camera-pitch-mr');

    /**
     * Pitch On Off Switch Trigger
     */

    if (!$switchBearing.is(':checked')) {
      $sectionMultiRange.hide();
    }

    $switchBearing.click(function() {
      if ($(this).prop('checked')) {
        $sectionMultiRange.show();
      } else {
        $sectionMultiRange.hide();
      }
    });

    window.addEventListener('click', function(event) {

      TWER.map.on('pitch', function() {
        let pitchData = parseFloat(TWER.map.getPitch()).toFixed(2);
        let bearingData = parseFloat(TWER.map.getBearing()).toFixed(2);

        // Set Pitch
        $initialPitch.val(pitchData);
        $initialPitchRange.val(pitchData);

        // Set Bearing
        $initialBearing.val(bearingData);
        $initialBearingRange.val(bearingData);

      });

    });

    function setInitialBearing(bearing) {
      let vB = parseFloat(bearing).toFixed(2);
      $initialBearing.val(vB);
      $initialBearingRange.val(vB);
      TWER.map.setBearing(vB);
    }

    function setInitialPitch(pitch) {
      let vP = parseFloat(pitch).toFixed(2);
      $initialPitch.val(vP);
      $initialPitchRange.val(vP);
      TWER.map.setPitch(vP);
    }

    /**
     * Change Pitch & Bearing level based on range value, input value
     *
     */
    $initialBearing.add($initialBearingRange).on('input', function() {
      setInitialBearing($initialBearing.val());
    });

    $initialPitch.add($initialPitchRange).on('input', function() {
      setInitialPitch($initialPitch.val());
    });

    /** Multirange **/

    /**
     * Set zoom min/max level
     */
    $('#range-treweler-camera-pitch-mr, #range-treweler-camera-pitch-mr-right').on('input', function() {
      let lR = parseFloat($('#range-treweler-camera-pitch-mr').val());
      let uR = parseFloat($('#range-treweler-camera-pitch-mr-right').val());

      if ($(this).hasClass('lower-slider')) {
        if (!$(this).hasClass('active')) {
          $(this).addClass('active');
          $('.upper-slider').removeClass('active');
        }
        if (uR <= lR + 1) {
          $('#range-treweler-camera-pitch-mr-right').val(lR + 2);
          if (uR == lR) {
            $('#range-treweler-camera-pitch-mr-right').val(lR + 2);
          }
        }
      } else if ($(this).hasClass('upper-slider')) {
        if (!$(this).hasClass('active')) {
          $(this).addClass('active');
          $('.lower-slider').removeClass('active');
        }
        if (lR >= uR - 1) {
          $('#range-treweler-camera-pitch-mr').val(uR - 2);
          if (uR == lR) {
            $('#range-treweler-camera-pitch-mr').val(uR - 2);
          }
        }
      }
      let min = parseFloat($('#range-treweler-camera-pitch-mr').val()),
        max = parseFloat($('#range-treweler-camera-pitch-mr-right').val());

      $('#num-treweler-camera-pitch-mr').val(min);
      $('#num-treweler-camera-pitch-mr-right').val(max);
      $initialPitchRange.attr({'min': min, 'max': max});
      $initialPitch.attr({'min': min, 'max': max});

      if (min >= parseFloat($initialPitch.val())) {
        $initialPitch.val(min);
        $initialPitchRange.val(min).trigger('input');
      } else if (max <= parseFloat($initialPitch.val())) {
        $initialPitch.val(max);
        $initialPitchRange.val(max).trigger('input');
      }

      TWER.map.setMinPitch(min);
      TWER.map.setMaxPitch(max);
    });

    /**
     * Set zoom min/max level from input box
     */
    $('#num-treweler-camera-pitch-mr, #num-treweler-camera-pitch-mr-right').on('input', function() {
      let minI = parseFloat($('#num-treweler-camera-pitch-mr').val()),
        maxI = parseFloat($('#num-treweler-camera-pitch-mr-right').val());
      $('#range-treweler-camera-pitch-mr').val(minI);
      $('#range-treweler-camera-pitch-mr-right').val(maxI);
      $initialPitchRange.attr({'min': minI, 'max': maxI});
      $initialPitch.attr({'min': minI, 'max': maxI});

      if (minI >= parseFloat($initialPitch.val())) {
        $initialPitch.val(minI);
        $initialPitchRange.val(minI).trigger('input');
      } else if (maxI <= parseFloat($initialPitch.val())) {
        $initialPitch.val(maxI);
        $initialPitchRange.val(maxI).trigger('input');
      }

      TWER.map.setMinPitch(minI);
      TWER.map.setMaxPitch(maxI);
    });

    /**
     * Tour Fly
     */

    const $TourType = $('#treweler-tour-type');
    const $TourSectionSpeed = $('.section-treweler-tour-fly-speed');
    const $TourSectionCurve = $('.section-treweler-tour-fly-curve');

    if ($TourType.val() !== 'fly') {
      $TourSectionSpeed.hide();
      $TourSectionCurve.hide();
    }

    $TourType.change(function() {
      if ($(this).val() === 'fly') {
        $TourSectionSpeed.show();
        $TourSectionCurve.show();
      } else {
        $TourSectionSpeed.hide();
        $TourSectionCurve.hide();
      }

      $('.js-adv-checkbox').trigger('change');
    });

  });
})(jQuery);

import TWER_WIDGETS from './modules/widgets';
import TWER_WIDGETS_MARKER from './modules/widgets-marker';
import TWER_UPLOADS from './modules/uploads';
import TWER_CONTROLS from './modules/controls';

jQuery(document).ready(function($) {
  new TWER_UPLOADS($);
  new TWER_WIDGETS($);
  new TWER_WIDGETS_MARKER($);
  new TWER_CONTROLS($);

});
